"use client";

import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { cn } from "@/lib/utils";
import { NavigationItemSlice } from "@/prismicio-types";
import { components } from "@/slices";
import type { SliceZone as SliceZoneType } from "@prismicio/client";
import { SliceZone } from "@prismicio/react";
import { usePathname } from "next/navigation";

type FaqsSidebarProps = {
  className?: string;
  slices: SliceZoneType<NavigationItemSlice>;
  locale: Locales;
};

const FaqsSidebar = ({ slices, locale }: FaqsSidebarProps) => {
  const pathname = usePathname();

  return (
    <aside className="min-w-[17.5rem] flex-1 lg:max-w-[21.375rem]">
      <nav aria-label={__("FAQS Navigation", locale)}>
        <ul
          className={cn(
            "max-lg:border-border-light/50 w-full overflow-hidden rounded-md border-x border-t border-transparent lg:space-y-3 [&_li:last-child>a]:rounded-b-md"
          )}
        >
          <SliceZone slices={slices} components={components} context={{ pathname }} />
        </ul>
      </nav>
    </aside>
  );
};

export default FaqsSidebar;
